import { useState } from 'react';
import { intersection } from 'lodash';

import { useEffectOnce } from './useEffectOnce';

const TRANSLATED_CLASS_NAMES = ['translated-ltr', 'translated-rtl'];

const isClassListContainTranslated = (classList: DOMTokenList): boolean => {
  const classes = Array.from(classList);

  return intersection(classes, TRANSLATED_CLASS_NAMES).length > 0;
};

/**
 * Hook that detects if the page is translated (has translation classes)
 * @returns Boolean indicating if the page is currently translated
 */
export const useIsTranslated = (): boolean => {
  const [isTranslated, setIsTranslated] = useState<boolean>(false);

  useEffectOnce(() => {
    const html = document.querySelector('html');
    if (!html) {
      return;
    }

    setIsTranslated(isClassListContainTranslated(html.classList));

    // Options for the observer (which mutations to observe)
    const config = { attributes: true, childList: false, subtree: false };

    const callback = (mutationList: MutationRecord[]): void => {
      mutationList.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const target = mutation.target as Element;
          setIsTranslated(isClassListContainTranslated(target.classList));
        }
      });
    };

    const observer = new MutationObserver(callback);
    observer.observe(html, config);

    return () => {
      observer.disconnect();
    };
  });

  return isTranslated;
};
